import React from 'react';
import {View, Text, TouchableOpacity, Dimensions} from 'react-native';
import {useSelector} from 'react-redux';
import logger from './logger'; // Or remove if you don't use logger
import {selectLandscapeSmallWebView} from '../redux/slices/ScreenOrientationSlice';
import {isAndroid, isiOS} from './utils';

export default function CourseSlideEventOnVideo(props) {
  const {
    pdata,
    dimentionData,
    containerStyle,
    eventCallcack, // callback spelled 'eventCallcack' in your code
  } = props;

  // Make sure 'pdata' is always an array
  const arrayOfEventNodes = Array.isArray(pdata) ? pdata : [pdata];

  // For debugging
  logger('CourseSlideEventOnVideo: pData =>', arrayOfEventNodes);

  const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);

  return (
    <View style={containerStyle}>
      {arrayOfEventNodes.map((node, i) => {
        // Safely check if there's a courseSlideElement
        if (!node?.courseSlideElement) {
          logger(`Node #${i}: missing courseSlideElement. Skipping.`);
          return null;
        }

        const cse = node.courseSlideElement.CourseSlideElement;
        if (!cse) {
          logger(`Node #${i}: missing CourseSlideElement array/object. Skipping.`);
          return null;
        }

        if (node.courseSlideElement?.pauseOnElement === 'true') {
         logger('Pause triggered by pauseOnElement');
         setIsPlaying(false);
         pauseMacVideo();
      }
      

        // cse might be single object or array
        const slideElements = Array.isArray(cse) ? cse : [cse];

        return (
          <View key={`node_${i}`} pointerEvents="box-none">
            {slideElements.map((elem, j) => (
              <GenerateDynamicButton
                key={`elem_${j}`}
                viewRect={elem}
                videoDimention={dimentionData}
                onClickEvent={eventCallcack}
              />
            ))}
          </View>
        );
      })}
    </View>
  );
}

function GenerateDynamicButton(props) {
  const {viewRect, videoDimention, onClickEvent} = props;
  if (!viewRect?.courseSlideRectData) {
    return null;
  }

  // Extract dimension info
  const {width: vidW, height: vidH} = videoDimention.videoDimention;
  const {width: plyW, height: plyH} = videoDimention.playerDimention;
  const rectData = viewRect.courseSlideRectData;

  // Basic ratio
  const xRatio = plyW / vidW;
  const yRatio = plyH / vidH;

  // Convert top/left/width/height from the XML
  const mLeft = parseFloat(rectData.Left) * xRatio;
  const mTop = -parseFloat(rectData.Top) * yRatio;
  const mWidth = parseFloat(rectData.Width) * xRatio;
  const mHeight = parseFloat(rectData.Height) * yRatio;

  const backgroundColor = makeRGBA(viewRect.courseSlideElementImage);

  // If it's a clickable element
  if (viewRect._ElementType === '1') {
    return (
      <TouchableOpacity
        pointerEvents="auto"
        onPress={() => onClickEvent?.(viewRect)}
        style={{
          position: 'absolute',
          top: mTop,
          left: mLeft,
          width: mWidth,
          height: mHeight,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor,
        }}
      >
        {/* Possibly show text or an icon here */}
      </TouchableOpacity>
    );
  } else {
    // Non-clickable text, etc.
    if (!viewRect.courseSlideElementText) {
      return null;
    }

    // We need some ratio functions if we do "relativePosY" / "relativeWidth" etc
    // but let's keep it simple: re-use the same top/left as mTop / mLeft
    return (
      <Text
        key={`text_${viewRect._ElementID}`}
        style={{
          position: 'absolute',
          top: mTop,
          left: mLeft,
          width: mWidth,
          height: mHeight,
          color: makeRGBA(viewRect.courseSlideElementImage),
          fontSize: 24,
        }}
      >
        {viewRect.courseSlideElementText?.textString}
      </Text>
    );
  }
}

function makeRGBA(imgObj = {}) {
  const r = parseFloat(imgObj.colorR ?? 0) * 255;
  const g = parseFloat(imgObj.colorG ?? 0) * 255;
  const b = parseFloat(imgObj.colorB ?? 0) * 255;
  const a = parseFloat(imgObj.colorA ?? 1);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}
